export default __webpack_public_path__ + "static/media/cancha_2 American Express.ced6ae42.jpg";